// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__15qx1","footer":"ModalError_footer__1mpzI"};